import React, { Component } from "react"
import { Grid, Row, Col, Well } from 'react-bootstrap'
import { connect } from 'react-redux'
import ReactJson from 'react-json-view'


import '../../Modals/Modal.css'



class SesamThreadDisplay extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { thread } = this.props
console.log(thread)
        return (
            <div>
                <Well>
                    AccessRequests: <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={thread.accessRequests} />
                </Well>

                <Well>
                    AccessKeys: <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={thread.accessKeys} />
                </Well>

                <Well>
                    AccessEvents: <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={thread.accessEvents} />
                </Well>
            </div>
        )

    }
}

const mapState = state => {
    return {
    }
}

const mapDispatch = (dispatch) => {
    return {
    }
}

export default connect(mapState, mapDispatch)(SesamThreadDisplay)